import { render, staticRenderFns } from "./1to7button.vue?vue&type=template&id=39d34086&"
import script from "./1to7button.vue?vue&type=script&lang=js&"
export * from "./1to7button.vue?vue&type=script&lang=js&"
import style0 from "./1to7button.vue?vue&type=style&index=0&id=39d34086&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports